import axios from '@util/axios';

import requestManager from "../components/platformApi/requestManager";
import appHelper from "../util/appHelper";

export default {

    /**
     * @param   Object params
     */
    list : function(params) {
        return axios({
            url: 'portal/base/overallCategory/allList',
            params: params
        });
    },

    loadList(typeEnum, callback) {
        requestManager.request({
            url: 'portal/base/overallCategory/allList',
            data: {
                typeEnum : typeEnum.toLocaleUpperCase()
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.showHint(error);
                return;
            }

            if(result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    }

};
